export enum CHECKBOX_RADIO_SIZE {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
